import styled from "styled-components";
import img from "../../img/tagline-bg.webp";
import { Link } from "react-router-dom";

export const FooterSection = styled.footer``;

export const AccentContainer = styled.div`
  background-color: var(--accent-50);
  padding: 80px 0;
  background-image: url(${img});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  & .footer-title {
    font-size: 3rem;
    color: var(--body-background);
  }

  @media (max-width: 991px) {
    padding: 50px 0;
    & .footer-title {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 600px) {
    padding: 30px 0;
    & .footer-title {
      font-size: 1.5rem;
    }
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  align-items: center;

  & .button-container {
    justify-self: end;
  }

  @media (max-width: 991px) {
    gap: 24px;
  }
  @media (max-width: 600px) {
    gap: 16px;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    place-items: center;
    & .button-container {
      justify-self: center;
    }
  }
`;

export const LinkStyled = styled(Link)`
  font-size: 1rem;
  text-decoration: none;
  color: var(--color);
  font-weight: 500;
  line-height: normal;
  padding: 1rem 1.5rem;
  border-radius: 4rem;
  background: var(--body-background);
  margin-right: 2.5rem;
  transition: all 0.3s;

  @media (max-width: 991px) {
    margin-right: 1.2rem;
    font-size: 0.95rem;
    padding: 0.8rem 1.2rem;
  }
  @media (max-width: 600px) {
    margin-right: 0.5rem;
    font-size: 0.9rem;
    padding: 0.7rem 1rem;
  }
`;

export const AdditionalContainer = styled.div`
  margin-top: 100px;
  padding: 30px 0;
  border-top: 1px solid var(--second-color);

  & .footer-copyright {
    display: flex;
    justify-content: center;

    & p {
      font-size: 1.2rem;
      color: var(--second-color);
    }
  }

  @media (max-width: 991px) {
    margin-top: 60px;
    padding: 20px 0;
    & .footer-copyright p {
      font-size: 1rem;
    }
  }
  @media (max-width: 600px) {
    margin-top: 30px;
    padding: 12px 0;
    & .footer-copyright p {
      font-size: 0.9rem;
    }
  }
`;
